import { render, staticRenderFns } from "./editFiles.vue?vue&type=template&id=1d6eb1b0&"
import script from "./editFiles.vue?vue&type=script&lang=js&"
export * from "./editFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6eb1b0')) {
      api.createRecord('1d6eb1b0', component.options)
    } else {
      api.reload('1d6eb1b0', component.options)
    }
    module.hot.accept("./editFiles.vue?vue&type=template&id=1d6eb1b0&", function () {
      api.rerender('1d6eb1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/CompanyManagement/Payslip/components/editFiles.vue"
export default component.exports